import { screenConnect } from "@screen";
import BaseComponent from "@js/components/base_component.jsx";
import {
  ceScreenEditorSave,
  ceScreenEditorCancel,
} from "@js/actions/studio/campaign_content_section/screen_editor.js";

class EditorTextarea extends BaseComponent {
  componentDidMount() {
    this.props.connector.subscribe(this.onConnectorEvent);
  }

  componentWillUnmount() {
    // We need to clear the subscription to the connector
    // Otherwise, a user could open a new editor and click cancel before
    // the subscription is overwritten, causing reference errors.
    let nullFunc = () => {};
    this.props.connector.subscribe(nullFunc);
  }

  render() {
    return (
      <textarea
        ref={(n) => { this._rootNode = n; }}
        id={"ce-editor-textarea"}
        defaultValue={
          this.props.format === "text" ? this.props.text : this.props.html
        }
        onBlur={null}
      />
    );
  }

  onConnectorEvent(e) {
    switch (e.type) {
      case "save":
        var value = this.getEditorValue();

        if (this.props.format === "text") {
          this.props.dispatch(ceScreenEditorSave(null, null, value));
        } else {
          this.props.dispatch(ceScreenEditorSave(null, value, null));
        }

        break;

      case "insert": {
        const input = this._rootNode;
        const cursor = getInputSelection(input);

        let value = input.value;
        value = value.replace(/\r\n/g, "\n");
        value =
          value.slice(0, cursor.start) + e.value + value.slice(cursor.end);

        input.value = value;

        this.setCursorPosition(input, cursor.start + e.value.length);

        break;
      }
      case "replace": {
        const input = this._rootNode;

        input.value = e.value;

        this.setCursorPosition(input, 0);
        break;
      }

      case "cancel": {
        let currentValue = this.getEditorValue();
        let initialValue =
          this.props.format === "text" ? this.props.text : this.props.html;
        let hasChanges = currentValue !== initialValue;
        this.props.dispatch(ceScreenEditorCancel(hasChanges));
        break;
      }
    }
  }

  setCursorPosition(input, pos) {
    if (input.setSelectionRange) {
      input.focus();
      input.setSelectionRange(pos, pos);
    } else if (input.createTextRange) {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveEnd("character", pos);
      range.moveStart("character", pos);
      range.select();
    }
  }

  getEditorValue() {
    return $(this._rootNode).val();
  }
}

export default screenConnect(EditorTextarea);
